/* esm.sh - @radix-ui/react-roving-focus@1.1.11 */
export * from "/*@radix-ui/react-roving-focus@1.1.11/esnext/react-roving-focus.mjs";
